import React, { useEffect } from 'react';
import './index.css';

const FreqAsked = () => {
  useEffect(() => {
    const faqItems = document.querySelectorAll('.faq-item');

    const handleClick = (event) => {
      const item = event.currentTarget.parentElement;
      item.classList.toggle('active');
      const icon = item.querySelector('.faq-icon');
      icon.textContent = item.classList.contains('active') ? '-' : '+';
    };

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      question.addEventListener('click', handleClick);
    });

    return () => {
      faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        question.removeEventListener('click', handleClick);
      });
    };
  }, []);

  const faqData = [
    {
      question: "Does the service include taxes, tolls and gratuity?",
      answer: "The service includes taxes and tolls. Gratuity is optional."
    },
    {
      question: "Where would the driver pick me up at the airport when I arrive?",
      answer: "It would be a curbside pick up. When the flight landed and you claim your luggage, you'll contact the driver and he would give you the pick up information. We'll send you the driver's information before your flight is landed."
    },
    {
      question: "How will the driver know if my flight is delayed?",
      answer: "Our software & also drivers track the flights."
    },
    {
      question: "What is your cancellation policy?",
      answer: "2 hours before no fee. If the flight gets cancelled we do full refund."
    },
    {
      question: "Can we include car seats on the service?",
      answer: "Each car seat has a cost of $15 extra."
    },
    {
      question: "Do you do meet and greet with a sign?",
      answer: "Meet and greet is $15 extra."
    },
    {
      question: "What is the minimum hours for an hourly service?",
      answer: "Minimum 2 hours."
    },
    {
      question: "Can I pay to the driver?",
      answer: "Payment must be done prior the trip for the booking to be 100% confirmed."
    },
    {
      question: "How much time do I have to meet the driver after my flight lands? Is there an extra fee if I take more time?",
      answer: "1 hour should be enough for you to meet the driver after the flight lands and you claim your luggage. In the case you take more time we charge $1 per minute."
    }
  ];

  return (
    <div className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-columns">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question">
              {item.question}
              <span className="faq-icon">+</span>
            </div>
            <div className="faq-answer">{item.answer}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FreqAsked;
